import css from "./cells.module.css"

export function DayBorderCell() {
  return <div className={css["day-border-cell"]}></div>
}
